// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Vant from 'vant';
import Axios from 'axios'
import 'vant/lib/index.css';
import md5 from 'js-md5';
Axios.defaults.timeout = 1000 * 15
// Axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded'
Axios.defaults.baseURL ='https://app.xwyyjt.com/';

Axios.interceptors.request.use(config => {
  config.headers['sing'] =  md5("daea394d-cd4e-487e-acbc-9fd520ba8039" + "xinwang");
  return config
}, error => {

});


Axios.interceptors.response.use(res => {
  console.log(res)
  if (res && res.data && res.data.code === 201) {
    setTimeout(()=>{
      location.href= "#/logIn";
    },1500)
  }
  return res
  //设置vuex状态
}, (res) => {
  return res
});
Vue.prototype.$http=Axios;
Vue.use(Vant);
Vue.config.productionTip = false;


/**
 * 获取url参数
 * @param name
 * @returns {undefined}
 */
Vue.prototype.getQueryString = function(name) {
  let match = undefined;
  let href = window.location.href;
  let index = href.indexOf("?");
  if (index > -1 && href.match(new RegExp(name, "i"))) {
      let queryStr = href.slice(index + 1).replace(/#([^?]+)/g, "");
      let matches = queryStr.match(new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i"));
      match = matches && matches[2] ? decodeURIComponent(matches[2]) : undefined;
  }
  return match;
}
Vue.prototype.timeFormat = function (time) {
  var date = new Date(time * 1000);//时间戳为10位需*1000，时间戳为13位的话不需乘1000

  var Y = date.getFullYear() + '-';

  var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';

  var D = date.getDate() + ' ';

  var h = date.getHours() + ':';

  var m = date.getMinutes() + ':';

  var s = date.getSeconds();

  return Y + M + D + h + m + s;
}
/**
 * 下拉加载 兼容弹跳
 */
Vue.directive('bottomLoad', {
  inserted (el, binding) {
    let addData = binding.value.handle
    let distance = binding.value.distance
    let isTopRefresh = binding.value.isTopRefresh || false
    // el.style.height = window.innerHeight - el.getBoundingClientRect().top + 'px'
    // el.style.overflowX = 'hidden'
    el.style.overflowY = 'scroll'
    el.style.webkitOverflowScrolling = 'touch'
    el.addEventListener('scroll', () => {
      if (el.scrollTop + el.clientHeight + distance >= el.scrollHeight) {
        if (window.bottomLoadTimer) {
          clearTimeout(window.bottomLoadTimer)
        }
        window.bottomLoadTimer = setTimeout(function () {
          addData()
          delete window.bottomLoadTimer
        }, 300)
      }
    })
    setTimeout(function () {
      if (el.clientHeight >= el.scrollHeight) {
        addData()
      }
    }, 500)
    /**
     * 如果开启上拉刷新
     */
    if (isTopRefresh) {
      let refreshFn = binding.value.refreshFn
      let startY = 0  //手指触摸最开始的Y坐标
      let change = 0  //滑动的距离
      el.addEventListener('touchstart', (e) => {
        e.stopPropagation()
        startY = e.touches[0].pageY
        el.style.transition = 'all  0s'
        change = 0

      })
      el.addEventListener('touchmove', (e) => {
        e.stopPropagation()

        change = e.touches[0].pageY - startY
        if (el.scrollTop <=0 && change > 0) {
          e.preventDefault()
        }
        if (!el.scrollTop && change > 0 && (change < 50)) {
          el.style.transform = 'translateY(' + change + 'px)'
        }
      })

      el.addEventListener('touchend', (e) => {
        e.stopPropagation()
        if (el.scrollTop <= 0) {
          el.style.transition = 'all ease 0.5s'
          el.style.transform = 'translateY(0)'
          if (change > 20) {
            refreshFn && refreshFn()
          }
          change = 0
        }else {
          el.style.transform = 'translateY(0)'
        }
      })
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js